module.exports = __webpack_public_path__ + "img/1004_s.d4e262df.png";